import api from './api';

const uploadService = {
  uploadSingle: (file) => {
    const formData = new FormData();
    formData.append('image', file);
    // Don't set Content-Type manually — Axios auto-sets it with correct boundary for FormData
    return api.post('/uploads/single', formData);
  },

  uploadMultiple: (files) => {
    const formData = new FormData();
    files.forEach((file) => formData.append('images', file));
    return api.post('/uploads/multiple', formData);
  },
};

export default uploadService;
